module.exports = __webpack_public_path__ + "static/media/pet-race-dog.32650079.svg";